// extracted by mini-css-extract-plugin
module.exports = {"stars":"RatePicker_stars__1L3J4"};